export default __webpack_public_path__ + "static/media/img6.73a7b875.png";